export default __webpack_public_path__ + "static/media/checkbox-8B8B8B.cf0730d1.svg";